/*
export function someMutation (state) {
}
*/

export function SET_LIVROS_POR_SERVICO(state, payload) {
  state.livrosPorServico = payload;
}
